/**********************************

Cookie functions

***********************************/

// Sets a cookie with the given name and value for the current session.
function setSessionCookie(name, value) {
  document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; SameSite=Lax; Secure";
}

// Gets a cookie with the given name.
function getSessionCookie(name) {
  const nameKey = name + "=";
  const cArr = document.cookie.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(nameKey) === 0) res = decodeURIComponent(val.substring(nameKey.length));
  });
  return res;
}

/***********************************/

// Start IPStack Geotargeting based on customers zipcode //

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  var encodedValue = value != null ? encodeURIComponent(value) : "";
  document.cookie = name + "=" + encodedValue + expires + "; path=/; SameSite=Lax; Secure";
}

// Treat null/undefined/empty/'undefined'/'null' all as "no ZIP".
function hasValidZipCookie() {
  var z = getCookie("zipcode");
  return !!z && z !== 'undefined' && z !== 'null' && /^\d{5}$/.test(z);
}

// Held as a legacy global because other theme files (e.g.
// worldpantry-inventory-product.liquid) read `zipcode` directly without
// calling getCookie. Always prefer getCookie("zipcode") for the freshest
// value — this global is only kept in sync at script load and after the
// IPStack response below.
var zipcode = getCookie("zipcode");
var access_key = '9da7c901697562382ec847a53ec9dd4e';

// Only call IPStack when we don't already have a usable ZIP. The old check was
// `if (zipcode == '')`, but getCookie returns null when missing and null !== ''
// in JS, so the IPStack call effectively never ran.
if (!hasValidZipCookie()) {
  $.ajax({
    url: 'https://api.ipstack.com/check?access_key=' + access_key,
    dataType: 'jsonp',
    success: function (json) {
      if (json && json.zip && /^\d{5}$/.test(json.zip)) {
        setCookie("zipcode", json.zip, 5);
        zipcode = json.zip; // keep the legacy global in sync
      }
    }
  });
} else {
  console.log('geotargeting working');
}

// Start Geotargeting First Load Fix //
// Auto-populate the modal's ZIP input from the geo cookie and trigger a
// lookup. Only run when we actually have a real 5-digit ZIP — otherwise we
// were submitting the form with an empty value, getting an empty API
// response, and rendering "ZIP Code not found" on first page load.
function geoTarget() {
  if (!hasValidZipCookie()) {
    console.log("fast geo: no valid zip cookie, skipping auto-submit");
    return;
  }
  var zipcode = getCookie("zipcode");
  console.log("fast geo zip " + zipcode);
  $("#enterzipcode").val(zipcode);
  $("#shipping-arrival").trigger('submit');
}

setTimeout(geoTarget, 1000);
// End Geotargeting First Load Fix //

// End IPStack Geotargeting based on customers zipcode //

/**********************************

Product Inventory functions

***********************************/

const OutOfStockAlwaysSellStatusDisplay = "Usually ships in 1-2 weeks.";
const OutOfStockAlwaysSellCartStatusDisplay = 'Alert: Item(s) highlighted below should be back in stock in 1-2 weeks. Remove or replace them to have your order ship now.';
const OutOfStockAlwaysSellCartItemStatusDisplay = 'More stock expected in 1-2 weeks - will delay your entire order';

// Builds the In Stock display HTML with the arrival month baked in from the
// FastShip.OrderByMonth cookie. Was previously a static const string with an
// empty <span>, which relied on the shipping bar's $('.arrival_month').text()
// running AFTER the HTML was inserted -- a race condition. By building it as
// a function we capture the date at render time instead.
function getInStockAlwaysSellStatusDisplay() {
  var arrivalMonth = getSessionCookie('FastShip.OrderByMonth') || '';
  return "In Stock" +
    "</br>" +
    "<div id='shipping-message' class='shipping-message'>" +
      "<p id='cta_order_by'>For your area - Arrives" +
        "<strong class='arrival_month'><span>" + arrivalMonth + "</span></strong>" +
      "</p>" +
    "</div>";
}

// Gets product inventory JSON data from shop.worldpantry.com and calls the given setProductInventoryStatus function
function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var url = 'https://shop.worldpantry.com/productinventories/goodearth/productinventory.aspx';
  var postproductinventory = $.post(url, { zip: zip, key: 'WP_2021_GOODEARTH', productid: productId, variantid: variantId });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == 'OutOfStock' || data.Status == 'AlwaysSell') {
        data.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

// Gets WorldPantry product number and variant number for each item in the
// current cart. Returns a Promise that resolves to the parsed array.
function getProductNumbers() {
  return $.ajax({
    type: 'GET',
    url: '/cart?view=wp-productnumbers'
  }).then(function (response) {
    try {
      return JSON.parse(response);
    } catch (e) {
      console.error('getProductNumbers: failed to parse response', e);
      return null;
    }
  });
}

// Gets product inventories for the given list of WorldPantry product/variant
// numbers. Returns a Promise that resolves to the inventory array (or null
// when called with no items).
function getProductInventories(productNumbers) {
  if (!productNumbers || !productNumbers.length) {
    return $.Deferred().resolve(null).promise();
  }

  var items = [];
  for (var i = 0; i < productNumbers.length; i++) {
    items.push({
      productId: productNumbers[i].productNumber,
      variantId: productNumbers[i].variantNumber
    });
  }

  var shippingInfo = {
    zip: getCookie('zipcode'),
    items: items
  };
  var url = 'https://shop.worldpantry.com/productinventories/goodearth/productinventories.aspx';

  return $.ajax({
    type: 'POST',
    url: url,
    data: { key: 'WP_2021_GOODEARTH', shippingInfo: JSON.stringify(shippingInfo) }
  });
}

// Gets a product inventory status display for the cart item.
function getProductInventoryCartItemStatusDisplay(productInventory) {
  var inventoryCartItemStatusDisplay = 'In Stock';
  if (productInventory) {
    if (productInventory.Status == 'AlwaysSell' || productInventory.Status == 'OutOfStock') {
      inventoryCartItemStatusDisplay = OutOfStockAlwaysSellCartItemStatusDisplay;
    }
  }
  return inventoryCartItemStatusDisplay;
}

// Gets a product inventory status display for the cart.
function getProductInventoryCartStatusDisplay(productInventories) {
  var inventoryCartStatusDisplay = '';
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == 'AlwaysSell' || productInventories[i].Status == 'OutOfStock') {
        inventoryCartStatusDisplay = OutOfStockAlwaysSellCartStatusDisplay;
        break;
      }
    }
  }
  return inventoryCartStatusDisplay;
}

// Gets a product inventory for the given item ID.
function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (var i = 0; i < productInventories.length; i++) {
        if ((productInventories[i].ProductId.toUpperCase() == productNumber.toUpperCase()) &&
            (productInventories[i].VariantId.toUpperCase() == variantNumber.toUpperCase())) {
          inventoryStatus = productInventories[i];
          if (inventoryStatus.Status == "OutOfStock") {
            inventoryStatus.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
          } else {
            inventoryStatus.StatusDisplay = getInStockAlwaysSellStatusDisplay();
          }
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}

/**********************************

Start Reload Cart Page with Live Inventory

***********************************/

var firstChange = true;

function reloadCart() {
  var target = document.querySelector('[data-subtotal]');
  if (!target) return;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      if (firstChange) {
        firstChange = false;
        return;
      } else {
        firstChange = true;
        // NOTE: original code was `setTimeout(window.location.reload())`,
        // which invokes reload() immediately (its return value, undefined,
        // is what gets passed to setTimeout). Behavior preserved.
        window.location.reload();
      }
    });
  });
  var config = { attributes: true, childList: true, characterData: true };
  observer.observe(target, config);
}

document.addEventListener("DOMContentLoaded", function () {
  reloadCart();

  var selectElements = document.getElementsByClassName('js-qty__adjust');
  var allOne = true;
  for (var i = 0; i < selectElements.length; i++) {
    if (selectElements[i].getAttribute("value") > 1) {
      allOne = false;
    }
  }
  console.log(allOne);
  if (allOne === true) {
    firstChange = false;
  }
});

/**********************************

End Reload Cart Page with Live Inventory

***********************************/
